import React from 'react';
/**
 * @function keyed
 * @since 1.0.0
 * @hidden
 */
export function keyed(children) {
    const values = {};
    React.Children.forEach(children, (child) => {
        if (values[child.key] == null) {
            values[child.key] = child;
        }
    });
    return values;
}
